import {css} from 'lit';
export const styles = css`:host {
  --label-color: var(--gray-900, #212529);
  --heading-color: var(--gray-600, #868e96);
  --border-color: var(--gray-200, #e9ecef);

  display: block;
}

figure {
  margin: 0;
}

.caption {
  margin: 0 0 12px;
  color: var(--label-color);
  font-size: 0.9375rem;
  font-weight: 600;
  text-align: left;
}

.empty {
  margin: 0;
  padding: 24px 0;
  color: var(--heading-color);
  font-size: 0.875rem;
  text-align: center;
}
`;
export default styles;
